import styled from "styled-components";
import { theme } from "@themes";
import "react-notifications/lib/notifications.css";

export const RouteUser = styled.div`
  display: inline-flex;
  width: 100%;
  p {
    margin-left: 1em;
    text-transform: capitalize;
  }
  span {
    color: ${({ theme }) => theme.button.primary};
    font-weight: 600;
  }
`;
export const BackButton = styled.div`
  cursor: pointer;
`;
export const SectionWrapper = styled.div`
  display: grid;
  padding: 0.4rem;
  grid-template-columns: 1fr 1em;
  grid-auto-rows: 1em auto;
  align-items: center;

  label {
    grid-column: 1/3;
    color: rgba(123, 123, 123, 1);
    font-size: 14px;
  }

  input,
  select {
    padding: 0.5em;
    width: 100%;
    border: 1px solid ${({ theme }) => theme.neutral.gray[900]};
    outline: 0;
    border-radius: 4px;
    box-sizing: border-box;
    font-size: 14px;
    color: ${({ theme }) => theme.primary.purple};
  }

  input::placeholder {
    font-size: 12px;
  }
`;

export const ContentDataUser = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  grid-gap: 0.6em;
  padding: 5px;
  @media only screen and (max-width: 768px) {
    display: flex;
    flex-direction: column;
  }
`;

export const OptionWrapper = styled.div`
  display: grid;
  width: 10em;
  float: left;
  margin-top: 6px;
  grid-gap: 5px;
  grid-template-columns: 1em 1fr;
  align-items: center;
  padding-right: 1em;

  label {
    padding: 5px;
    text-align: left;
    margin: 0;
    font-size: 14px;
    line-height: 19px;
  }
  input {
    transform: scale(1.3);
  }
  input[type="checkbox"]:checked {
    background: ${({ theme }) => theme.button.primary};
    color: ${({ theme }) => theme.neutral.white};
  }
  span {
    position: absolute;
    top: 0;
    left: 0;
    height: 25px;
    width: 25px;
    background-color: black;
  }
`;

export const ButtonUserCreate = styled.button`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 9em;
  height: 36px;
  left: 732px;
  top: 336px;
  background: ${({ theme }) => theme.button.primary};
  border-radius: 4px;
  border: none;

  color: white;
  cursor: pointer;
  a {
    color: ${({ theme }) => theme.neutral.gray[200]};
    text-decoration: none;
    background-color: transparent;
  }
  &:hover {
    box-shadow: 0px 4px 20px 0px ${({ theme }) => theme.shadows.strong};
    transform: translateY(-1px);
    cursor: pointer;
  }
`;
export const ButtonUserCancel = styled.button`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 9em;
  height: 36px;
  left: 732px;
  top: 336px;
  background: white;
  border-radius: 4px;
  border: 1px solid;

  color: ${({ theme }) => theme.button.primaryBorder};
  cursor: pointer;
  a {
    color: ${({ theme }) => theme.neutral.gray[200]};
    text-decoration: none;
    background-color: transparent;
  }
  &:hover {
    box-shadow: 0px 4px 20px 0px ${({ theme }) => theme.shadows.strong};
    transform: translateY(-1px);
    cursor: pointer;
  }
`;
export const ButtonDownloadTemplate = styled.button`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 14em;
  height: 36px;
  left: 732px;
  top: 336px;
  background: white;
  border-radius: 4px;
  border: 1px solid;

  color: ${({ theme }) => theme.button.primary};
  cursor: pointer;
  a {
    color: ${({ theme }) => theme.neutral.gray[200]};
    text-decoration: none;
    background-color: transparent;
  }
`;
export const ContentSaveUserButtons = styled.div`
  display: ${({ action }) => action === "edit" ? "flex" : "inline-flex"};
  justify-content: ${({ action }) => action === "edit" ? "space-between" : "inherit"};
  grid-gap: 1em;
  width: 90vw;
  padding: 1em 5px 0 9px;
  border-top: solid rgba(230, 230, 230, 1) 1px;
  margin-top: 2em;
`;
export const ContentAddAccountButtons = styled.div`
  display: flex;
  justify-content: flex-start;
  width: 90vw;
  padding: 1em 5px 0 9px;
  margin-top: 2em;
`;
export const ContentAddAccountSection = styled.div`
  margin-top: 2em;
  padding: 1em 5px 0 9px;
`
export const ContentFieldsAddAccount = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  grid-gap: 0.6em;
  padding: 5px;
  @media only screen and (max-width: 768px) {
    display: flex;
    flex-direction: column;
  }
`
export const TitleAddAccount = styled.p`
  font-weight: bold;
  font-size: 14px;
  margin-left: 0.8em;
`
export const ButtonAddAccount = styled.button`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 9em;
  height: 36px;
  left: 732px;
  top: 336px;
  background: white;
  border-radius: 4px;
  border: 1px solid;
  color: ${({ theme }) => theme.button.primary};
  cursor: pointer;
  &:hover {
    box-shadow: 0px 4px 20px 0px ${({ theme }) => theme.shadows.strong};
    transform: translateY(-1px);
    cursor: pointer;
  }
`
export const TitleUserModule = styled.div`
  display: inline-flex;
  align-items: center;
  color: rgba(123, 123, 123, 1);
  width: 90vw;
  border-bottom: solid rgba(230, 230, 230, 1) 1px;
  margin-bottom: 1em;
`;
export const TextTitleUser = styled.div`
  margin-left: 9px;
  margin-bottom: 0;
  font-weight: 700;
  font-size: 18px;
  text-transform: capitalize;
  margin-bottom: 10px;
`;

export const ContainerBulkUpload = styled.div`
  display: grid;
  grid-template-columns: 28em 1fr;
  padding: 0em 2em;
  @media only screen and (max-width: 768px) {
    display: flex;
    flex-direction: column;
  }
  .FileUploadContainer {
    @media only screen and (max-width: 768px) {
      width: 100%;
    }
  }
`;
export const ContentPreviewBulk = styled.div`
  padding: 0em 2em;
`;
export const InfoBulkUpload = styled.div`
  padding: 25px 0;
  ul {
    padding: 0;
  }
  li {
    list-style-type: none;
    font-size: 14px;
  }
  img {
    margin-right: 10px;
  }
`;
export const MessageError = styled.span`
  color: red;
`;

export const SectionWrapperLob = styled.div`
  display: grid;
  padding: 0.4rem;
  grid-column: 1/5;
  grid-template-columns: 1fr;
  grid-auto-rows: 1.5em auto;
  align-items: center;
  @media only screen and (max-width: 768px) {
    display: flex;
    flex-direction: column;
  }

  label:nth-child(1) {
    font-weight: 600;
    margin: 6px 14px 0 0;
  }

  input,
  select {
    padding: 0.5em;
    width: 100%;
    border: 1px solid ${({ theme }) => theme.neutral.gray[900]};
    outline: 0;
    border-radius: 4px;
    box-sizing: border-box;
    font-size: 14px;
    color: ${({ theme }) => theme.primaryIconColor};
  }

  input::placeholder {
    font-size: 12px;
  }
`;

export const ContentLob = styled.div`
  background: white;
  width: 80em;
  max-height: 10em;
  display: grid;
  grid-template-columns: repeat(6, 13em);
  padding: 1em;
  overflow-y: auto;
  margin-top: 1em;
  @media only screen and (max-width: 768px) {
    width: 100vw;
    overflow-x: hidden;
    grid-template-columns: auto auto;
    margin-left: 7%;
    padding: 10px;
  }
  &::-webkit-scrollbar {
    width: 0.3em;
  }
  &::-webkit-scrollbar-thumb {
    background: #0008ff85;
    border-radius: 3px;
    border: 1px solid #c7b9c475;
  }
  &::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px #fdfdfd73;
    border-radius: 10px;
  }
`;

export const LobContentName = styled.div`
  background: rgb(240, 240, 240);
  padding: 5px;
  width: fit-content;
  margin-top: 10px;
  height: 29px;
  border-radius: 7px;
  div:nth-child(1) {
    background: ${({ theme }) => theme.primary.purple};
    color: white;
    border-radius: 13px;
    width: 14px;
    text-align: center;
    font-size: 11px;
    position: relative;
    top: -30px;
    left: 27px;
  }
`;
export const ContentSelectAll = styled.div`
  width: 76em;
  display: block;
  align-items: center;
  margin-bottom: 18px;
  @media only screen and (max-width: 768px) {
    width: 100vw;
  }
  .lob-selectall {
    @media only screen and (max-width: 768px) {
      margin-left: 4%;
    }
  }
`;
export const SearchLob = styled.div`
  display: flex;
  width: 36em;
  float: right;
  margin-right: 11px;
  @media only screen and (max-width: 768px) {
    flex-direction: column;
    width: 95%;
  }
  label {
    width: 19em;
    margin: 8px 0px !important;
  }
`;

export const ButtonDeleteAccount = styled.a`
  color: ${({ theme }) => theme.button.primary};
  cursor: pointer;
  font-weight: bold;
`
